export default class PaymentInformationValidationItem {
  constructor(item) {
    this.exportId = item?.exportId ?? null;
    this.file = null;
  }
}
